"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.polyfillIntlDisplayNames = void 0;

var tslib_1 = require("tslib");

var should_polyfill_1 = require("@formatjs/intl-displaynames/should-polyfill");

var should_polyfill_2 = require("@formatjs/intl-locale/should-polyfill");

function polyfillIntlDisplayNames(locale) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    var _a;

    return tslib_1.__generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (!(0, should_polyfill_2.shouldPolyfill)()) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-locale/polyfill'));
          })];

        case 1:
          _b.sent();

          _b.label = 2;

        case 2:
          if (!(0, should_polyfill_1.shouldPolyfill)()) return [3
          /*break*/
          , 4];
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/polyfill'));
          })];

        case 3:
          _b.sent();

          _b.label = 4;

        case 4:
          if (!Intl.DisplayNames.polyfilled) return [3
          /*break*/
          , 23];
          _a = locale;

          switch (_a) {
            case 'nl':
              return [3
              /*break*/
              , 7];

            case 'fr':
              return [3
              /*break*/
              , 9];

            case 'de':
              return [3
              /*break*/
              , 11];

            case 'he':
              return [3
              /*break*/
              , 13];

            case 'it':
              return [3
              /*break*/
              , 15];

            case 'ja':
              return [3
              /*break*/
              , 17];

            case 'pt':
              return [3
              /*break*/
              , 19];

            case 'es':
              return [3
              /*break*/
              , 21];
          }

          return [3
          /*break*/
          , 5];

        case 5:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/locale-data/en'));
          })];

        case 6:
          _b.sent();

          return [3
          /*break*/
          , 23];

        case 7:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/locale-data/nl'));
          })];

        case 8:
          _b.sent();

          return [3
          /*break*/
          , 23];

        case 9:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/locale-data/fr'));
          })];

        case 10:
          _b.sent();

          return [3
          /*break*/
          , 23];

        case 11:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/locale-data/de'));
          })];

        case 12:
          _b.sent();

          return [3
          /*break*/
          , 23];

        case 13:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/locale-data/he'));
          })];

        case 14:
          _b.sent();

          return [3
          /*break*/
          , 23];

        case 15:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/locale-data/it'));
          })];

        case 16:
          _b.sent();

          return [3
          /*break*/
          , 23];

        case 17:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/locale-data/ja'));
          })];

        case 18:
          _b.sent();

          return [3
          /*break*/
          , 23];

        case 19:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/locale-data/pt'));
          })];

        case 20:
          _b.sent();

          return [3
          /*break*/
          , 23];

        case 21:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return tslib_1.__importStar(require('@formatjs/intl-displaynames/locale-data/es'));
          })];

        case 22:
          _b.sent();

          return [3
          /*break*/
          , 23];

        case 23:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.polyfillIntlDisplayNames = polyfillIntlDisplayNames;